import {
  FontWeight,
  Heading,
  HeadingVariant,
  LiliOtp,
  LiliOtpType,
} from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { useBoundStore } from '@Store/index';
import { useSecurityQuestionLogic } from './hooks/useSecurityQuestionLogic';
import { StepFooter } from './shared/StepFooter';
import { MobileBackButton } from './shared/MobileBackButton';

export const SecurityQuestion = () => {
  const { t } = useTranslation();
  const { setSecurityQuestion, error, clearError, handleVerifySecurityQuestion, securityQuestion } =
    useSecurityQuestionLogic();
  const { navigateToPreviousPage } = useNavigationManager();
  const { isUs } = useBoundStore((state) => state.resetPasswordSlice);
  const { isMobile } = useResizeListener();
  return (
    <div className='recovery-page-container'>
      <MobileBackButton />
      <div className='flex flex-col pt-[56px] md:pt-[0px] w-full md:w-[520px] px-[24px] md:px-[42px] items-center'>
        <img src={logoUrl} alt='Lili Logo' className='w-[80px] mb-[32px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header'>
          {isUs
            ? t('recovery.securityQuestion.usResidentTitle')
            : t('recovery.securityQuestion.nonUsResidentTitle')}
        </Heading>
        <Heading.H10
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-secondary text-center mb-[24px]'>
          {isUs
            ? t('recovery.securityQuestion.usResidentSubtitle')
            : t('recovery.securityQuestion.nonUsResidentSubtitle')}
        </Heading.H10>
        <LiliOtp
          id='security-question'
          onCompleted={() => handleVerifySecurityQuestion}
          maxLength={4}
          type={LiliOtpType.CUSTOM}
          pattern={isUs ? '^[0-9]+$' : '^[A-Za-z0-9-]+$'}
          onChange={(value) => setSecurityQuestion(value)}
          onBlur={() => {}}
          onFocus={() => clearError()}
          errorMessage={error}
        />
        <StepFooter
          id='security-question'
          disabled={securityQuestion?.length !== 4}
          title={t('recovery.shared.footerContinue')}
          onClick={() => handleVerifySecurityQuestion()}
          onBackClick={() => navigateToPreviousPage()}
        />
      </div>
    </div>
  );
};
